import { Component } from 'src/utils';
import homeArrow from './../../../images/home-arrow.png';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import birdFood from './../../../images/bird-food.png';
import template from './product.html';
import tempUnavailable from './../../../images/tempunavailable_L.png';
import tempUnavailable_S from './../../../images/tempunavailable.png';

@Component({
  controllerAs: 'product',
  template
})

export default class Product {
  static $inject = [
      '$rootScope',
    '$scope',
    '$ngRedux',
    '$stateParams',
    '$state',
    'toaster',
    'orderService',
    'spinnerService',
    'orderActions',
    'authService',
    '$window',
    'APP',
    'ngMeta',
    '$location'
  ];

  constructor($rootScope,$scope, $ngRedux, $stateParams, $state, $toaster, $order, $spinner, orderActions, $auth, $window, APP, ngMeta, $location) {
    const disconnect = $ngRedux.connect(this.mapState)(this);

    this.homeArrow = homeArrow;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.birdFood = birdFood;
    this.$state = $state;
    this.$toaster = $toaster;
    this.$auth = $auth;
    this.$window = $window;
    this.APP = APP;
    this.ngMeta = ngMeta;
    this.$location = $location;
    this.tempUnavailable= tempUnavailable;
    this.tempUnavailable_S = tempUnavailable_S;
    $ngRedux.dispatch(orderActions.setProducts([]));
    this.$spinner = $spinner;
    this.$spinner.show('appSpinner');
    this.$stateParams = $stateParams;
    this.$order = $order;
    this.subCategoryName ='';
    this.categoryName = '';
    this.storeName = '';
    if(this.$auth.isLoggedIn() || this.$auth.isGuestLogin())
    {
      this.loadProducts();
    }
    if(this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      this.canUrl = this.$location.$$absUrl.replace(this.$location.$$url, '') +'/' +this.APP.ORDER.ORDER_URL.browseUrl +'/' + this.$stateParams.categoryId +'/' + this.$stateParams.subCategoryId;
      // this.canUrl = this.$location.$$absUrl.replace(this.$location.$$url, '') +'/' +this.$stateParams.storeName +'/' + this.$stateParams.categoryId +'/' + this.$stateParams.subCategoryId;
    } 
    else{
      this.canUrl = this.$location.$$absUrl;
    }

    console.log("this.canUrl.product : ",this.canUrl);
    this.ngMeta.setTag('canUrl',this.canUrl);

    var listener1 =  $rootScope.$on('onGuestLogin', () => this.loadProducts());
    $scope.$on('$destroy', () => {
    disconnect();
    listener1();
  });
  }

  mapState(state) {
    return {
      profile: state.auth.profile,
      list: state.order.products
    };
  }

  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }

  loadProducts(){
    if(this.profile.store && this.profile.store.storeName) {
      this.storeName = this.profile.store;
    } else {
      this.storeName = this.$auth.getGuestStoreDetail().storeName;
    }
    let categoryNameResponse = this.$order.getCateoryNamebyId(this.$stateParams.categoryId);
    categoryNameResponse.then(success => {
          
          this.categoryName = success.data;
          // this.$window.document.title =  this.categoryName.title ? this.categoryName.title : this.APP.ORDER.ORDER_URL.siteTitle;
    });
    let subCategoryNameResponse = this.$order.getSubCateoryNamebyId(this.$stateParams.subCategoryId);
    subCategoryNameResponse.then(success => {
          
          this.subCategoryName = success.data;
          // console.log("subCatName", this.subCategoryName);
          this.$window.document.title =  this.subCategoryName.title ? ( this.subCategoryName.title + ' | Wild Birds Unlimited') :this.APP.ORDER.ORDER_URL.siteTitle;
    });
    this.$order.getProducts(this.$stateParams.categoryId,this.$stateParams.subCategoryId)
        .then(success => {
          // console.log("Products Data", success.data);
          this.ngMeta.setTitle(success.data[0].itemList[0].masterProduct.subCategories[0].displayName);
          this.ngMeta.setTag('description',success.data[0].itemList[0].masterProduct.subCategories[0].description? success.data[0].itemList[0].masterProduct.subCategories[0].description : 'Product Page description');
          this.ngMeta.setTag('image',success.data[0].itemList[0].masterProduct.subCategories[0].smallImageUrl);
          this.ngMeta.setTag('alt',success.data[0].itemList[0].masterProduct.subCategories[0].alt ? success.data[0].itemList[0].masterProduct.subCategories[0].alt : 'Product Image');
      if (success.data[0] === null) {
      this.$toaster.pop('success', 'Sorry, There are no products currently');
      this.$state.go('category', {'storeName': this.$auth.getGuestStoreDetail().storeName });
    }
    console.log("Product list : ", this.list);
    var pwrItem = {};
    var pwrItemList = [];
    // var pwrIdDiv = document.getElementsByClassName("pwr-review");
    // console.log("pwrdIdDiv : ", pwrIdDiv);
    for(var i=1; i<=this.list.length; i++){
      // pwrIdDiv[i-1].id = "category-snippet-" + i;
      // pwrIdDiv[i-1].setAttribute("id", "category-snippet-" + i);
      pwrItem = {
        api_key: this.APP.AUTH.AUTH_URL.pwr.api_key,
        locale: this.APP.AUTH.AUTH_URL.pwr.locale,
        merchant_group_id: this.APP.AUTH.AUTH_URL.pwr.merchant_group_id,
        merchant_id: this.APP.AUTH.AUTH_URL.pwr.merchant_id,
        page_id: this.list[i-1].itemList[0].masterProduct.masterCode.substring(0, 7),
        components: {
           CategorySnippet: 'category-snippet-'+i
        }
        };
        if(i>1){
          pwrItem.enable_content_collection_modal= false;
        }
        pwrItemList.push(pwrItem);
    }
    console.log("pwrItemList : ", pwrItemList);
    window.pwr = window.pwr || function () {
      (window.pwr.q = window.pwr.q || []).push(arguments); 
     };
    setTimeout(() => {
     window.pwr("render", pwrItemList);
    }, 1500);
  })
  .finally(() => this.$spinner.hide('appSpinner'));
  }



  isCategorySubcatSame() {
    return this.list.length && (this.list[0].itemList[0].masterProduct.subCategories[0].name ===
      this.list[0].itemList[0].masterProduct.subCategories[0].category.name);
  }

  // parent is subcategory or category depending on subcategory existance
  getParentDetails() {
    if (this.isCategorySubcatSame()) {
      return this.list[0].itemList[0].masterProduct.subCategories[0].category;
    }
    else {
      return this.list.length && this.list[0].itemList[0].masterProduct.subCategories[0];
    }
  }

  goToDSCDetailPage() {
    //  console.log('goToDSCDetailPage');
    this.$state.go('savings-club');
  }

  isMobileDevice() {
    return this.$auth.isMobileDevice();
  }

  getCurrencyType(item) {
    if(item) {
      return item.store.country.countryCode == "US" ? 'USD' : 'CAD';
    }
    return 'USD';

  }

  // returns dsc price if it has else return normal price
  getRegularPrice(item) {
    return ' $'+(item.price).toFixed(2);
  }

  getDscPrice(item) {
    return ' $'+(item.price * 85 / 100).toFixed(2);
  }

  getPriceTag(product,isDsc) {
    var priceTag;
    var isDscCategory = product.itemList[0].masterProduct.subCategories[0].category.dscCategory;
    var maxItem = product.itemList[0];
    var regularMaxPrice = (isDsc) ? this.getDscPrice(maxItem) : this.getRegularPrice(maxItem);
    // checking max price
    if(product.itemList.length > 1) {
      var minItem = product.itemList[product.itemList.length-1];

      var regularMinPrice = (isDsc) ? this.getDscPrice(minItem) : this.getRegularPrice(minItem);
      priceTag =    regularMaxPrice;

    }
    else {
      priceTag =  regularMaxPrice;
    }

    return priceTag;

  }
  isIpad() {
    return ( this.$window.innerWidth < 1248 && this.$window.innerWidth > 767 );
  }

  isIpad_potrait() {
    return ( this.$window.innerWidth < 769 && this.$window.innerWidth > 1247 );
  }

  isOutOfStock(items){
    var isSubcatOutOfStock = false;
    var j= 0;
    for(var i=0; i<items.itemList.length; i++){
      if(items.itemList[i].isOutOfStock){
        j++;
      }
    }
    if(j==items.itemList.length){
      return true;
    }
  }

  isAvailablebackon(items){
    var availableOn = null;
    for(var i=0; i<items.itemList.length; i++){
      if(items.itemList[i].isOutOfStock){
        availableOn = items.itemList[i].availableBackOn;
        break;
      }
    }
    return availableOn;
  }
}



// WEBPACK FOOTER //
// ./src/app/order/product/product.js